/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSeller = /* GraphQL */ `
  mutation CreateSeller(
    $input: CreateSellerInput!
    $condition: ModelSellerConditionInput
  ) {
    createSeller(input: $input, condition: $condition) {
      id
      email
      name
      stripeID
      address
      phone
      postal
      createdAt
      updateAt
      products {
        items {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const updateSeller = /* GraphQL */ `
  mutation UpdateSeller(
    $input: UpdateSellerInput!
    $condition: ModelSellerConditionInput
  ) {
    updateSeller(input: $input, condition: $condition) {
      id
      email
      name
      stripeID
      address
      phone
      postal
      invoiceRegistrationNumber
      createdAt
      updateAt
      products {
        items {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const deleteSeller = /* GraphQL */ `
  mutation DeleteSeller(
    $input: DeleteSellerInput!
    $condition: ModelSellerConditionInput
  ) {
    deleteSeller(input: $input, condition: $condition) {
      id
      email
      name
      stripeID
      address
      phone
      postal
      createdAt
      updateAt
      products {
        items {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      title
      sellerID
      stripeID
      seller {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      URL
      price
      mailtext
      description
      note
      form
      imgURL
      stopFlag
      disableFlag
      identityId
      updatedAt
      createdAt
      customers {
        items {
          id
          productID
          email
          name
          note
          created_at
          chargeID
          reqRefund
          refundComment
          answer
          cancelled_at
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      title
      sellerID
      stripeID
      seller {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      URL
      price
      mailtext
      description
      note
      form
      imgURL
      stopFlag
      disableFlag
      identityId
      updatedAt
      createdAt
      customers {
        items {
          id
          productID
          email
          name
          note
          created_at
          chargeID
          reqRefund
          refundComment
          answer
          cancelled_at
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      title
      sellerID
      stripeID
      seller {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      URL
      price
      mailtext
      description
      note
      form
      imgURL
      stopFlag
      disableFlag
      identityId
      updatedAt
      createdAt
      customers {
        items {
          id
          productID
          email
          name
          note
          created_at
          chargeID
          reqRefund
          refundComment
          answer
          cancelled_at
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      email
      name
      note
      created_at
      chargeID
      reqRefund
      refundComment
      answer
      cancelled_at
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      email
      name
      note
      created_at
      chargeID
      reqRefund
      refundComment
      answer
      cancelled_at
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      email
      name
      note
      created_at
      chargeID
      reqRefund
      refundComment
      answer
      cancelled_at
    }
  }
`;
export const createProvide6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation CreateProvide6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: CreateProvide6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    createProvide6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      productID
      sellerID
      sellerName
      sellerPostal
      sellerAddress
      sellerPhone
      CustomerName
      ProvideItems
      TimeToLive
    }
  }
`;
export const updateProvide6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation UpdateProvide6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: UpdateProvide6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    updateProvide6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      productID
      sellerID
      sellerName
      sellerPostal
      sellerAddress
      sellerPhone
      CustomerName
      ProvideItems
      TimeToLive
    }
  }
`;
export const deleteProvide6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation DeleteProvide6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: DeleteProvide6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    deleteProvide6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      productID
      sellerID
      sellerName
      sellerPostal
      sellerAddress
      sellerPhone
      CustomerName
      ProvideItems
      TimeToLive
    }
  }
`;
export const getBalance = /* GraphQL */ `
  mutation GetBalance($input: GetBalanceInput!) {
    getBalance(input: $input) {
      statusCode
      body
    }
  }
`;
export const refund = /* GraphQL */ `
  mutation Refund($input: RefundInput!) {
    refund(input: $input) {
      statusCode
      body
    }
  }
`;
export const getStripeConnectId = /* GraphQL */ `
  mutation GetStripeConnectId($input: GetStripeConnectIDInput!) {
    getStripeConnectID(input: $input) {
      statusCode
      body
    }
  }
`;
export const delProduct = /* GraphQL */ `
  mutation DelProduct($input: DelProductInput!) {
    delProduct(input: $input) {
      statusCode
      body
    }
  }
`;
export const createPaymentIntent = /* GraphQL */ `
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
    createPaymentIntent(input: $input) {
      statusCode
      body
    }
  }
`;
export const chargeStripe = /* GraphQL */ `
  mutation ChargeStripe($input: ChargeStripeInput!) {
    chargeStripe(input: $input) {
      statusCode
      body
    }
  }
`;
export const reqRefund = /* GraphQL */ `
  mutation ReqRefund($input: UpdateReqRefund!) {
    reqRefund(input: $input) {
      statusCode
      body
    }
  }
`;
export const imgup = /* GraphQL */ `
  mutation Imgup($input: Imgup!) {
    imgup(input: $input) {
      statusCode
      body
    }
  }
`;
export const proAnswer = /* GraphQL */ `
  mutation ProAnswer($input: proAnswer!) {
    proAnswer(input: $input) {
      statusCode
      body
    }
  }
`;
export const contact = /* GraphQL */ `
  mutation Contact($input: Contact!) {
    contact(input: $input) {
      statusCode
      body
    }
  }
`;
export const ogpimg = /* GraphQL */ `
  mutation Ogpimg($input: Ogpimg!) {
    ogpimg(input: $input) {
      statusCode
      body
    }
  }
`;
export const adminResetPassword = /* GraphQL */ `
  mutation AdminResetPassword($input: adminResetPassword!) {
    adminResetPassword(input: $input) {
      statusCode
      body
    }
  }
`;
export const createAdmin6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation CreateAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: CreateAdmin6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    createAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      name
    }
  }
`;
export const updateAdmin6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation UpdateAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: UpdateAdmin6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    updateAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      name
    }
  }
`;
export const deleteAdmin6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation DeleteAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: DeleteAdmin6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    deleteAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      id
      name
    }
  }
`;
export const createSelling6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation CreateSelling6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: CreateSelling6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    createSelling6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      date
      month
      customers
      selling
    }
  }
`;
export const updateSelling6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation UpdateSelling6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: UpdateSelling6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    updateSelling6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      date
      month
      customers
      selling
    }
  }
`;
export const deleteSelling6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  mutation DeleteSelling6tmev5bluvberlff7ql57zqxu4Pittaput(
    $input: DeleteSelling6tmev5bluvberlff7ql57zqxu4PittaputInput!
  ) {
    deleteSelling6tmev5bluvberlff7ql57zqxu4Pittaput(input: $input) {
      date
      month
      customers
      selling
    }
  }
`;
